import React from 'react';
// import './faqs.scss';
import Accordion from 'react-bootstrap/Accordion';

const Faqsbuildpath = () => {
  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is Groups, and how does it work?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The Groups feature allows you to create and manage private or public communities with advanced tools for messaging, crypto payments, and anonymity. It is part of the TOMI app, designed to provide maximum privacy and access to decentralized tools."
        }
      },
      {
        "@type": "Question",
        "name": "How can I monetize my group?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can charge for membership or grant access to exclusive content. Payments are processed in crypto directly within the app, supporting decentralized wallets and various subscription models."
        }
      },
      {
        "@type": "Question",
        "name": "Can members stay anonymous?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Users can manage multiple profiles and participate in groups using anonymous identities. No phone number or email is required to sign up, and personal data remains hidden."
        }
      },
      {
        "@type": "Question",
        "name": "How is content moderation managed?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Groups come with advanced moderation tools, including permission controls, content removal, and group ownership transfer. Additionally, a DAO-based system helps determine which content is permissible."
        }
      },
      {
        "@type": "Question",
        "name": "How are payments handled within groups?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Transactions are made directly within the chat using crypto, with support for gasless transactions on selected blockchains."
        }
      },
      {
        "@type": "Question",
        "name": "Can I mix free and paid content within the same group?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. You can offer both free and premium content in the same group, allowing members to choose their level of engagement."
        }
      }
    ]
  };

  return (
    <section className='faqsmainprnt'>
      <div className="postionfaqs">
        <img className='img-fluid' src="/assets/faqpositionimg.png" alt="FAQs Background" />
      </div>
      <div className="custom-container">
        <div className="faqschldmain">
          <h2>FAQ</h2>
          <div className="faqscustumdesigine">
            <Accordion defaultActiveKey="0">
              {faqData.mainEntity.map((faq, index) => (
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Accordion.Header>
                    <h3 className="btninner">{faq.name}</h3>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p className="bodymain">{faq.acceptedAnswer.text}</p>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
      {/* Adding FAQ Schema for SEO */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqData) }} />
    </section>
  );
};

export default Faqsbuildpath;
